export default {
  namespaced: true,
  state: {
    crmRoutes: []
  },
  getters: {
  },
  mutations: {
    SET_CRM_ROUTES: (state, { authRoutes }) => {
      state.crmRoutes = authRoutes
    },
    saveCustomer(state, customer) {
      state.customer = customer
    }
  },
  actions: {
    saveCustomer(context, customer) {
      context.commit('saveCustomer', customer)
    }
  }
}
